export default "__VITE_ASSET__DYD8s4zS__"